import { faExclamationCircle, faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { HoverIconButton } from 'components/button/HoverIconButton';
import { useClickStopPropagationRef } from 'custom_hooks/useClickStopPropagationRef';
import { usePopup } from 'custom_hooks/usePopup';
import { TriggeredPopup } from 'shared/triggered_popup/TriggeredPopup';
import { tokens } from 'styles/tokens';
import { stopEvent } from 'utils/event';

export type IssueDisabledPopupProps = Readonly<{
    type: 'error' | 'info';
    message: string;
}>;

export function IssueDisabledPopup({ type, message }: IssueDisabledPopupProps) {
    const { triggerRef, popupRef, isOpen, toggleOpen, close } = usePopup();
    const contentRef = useClickStopPropagationRef<HTMLDivElement>();

    const isErrorType = type === 'error';
    const icon = isErrorType ? faExclamationCircle : faInfoCircle;
    const color = isErrorType ? tokens.error.default : tokens.text.secondary;
    const hoverColor = isErrorType ? tokens.error.dark : tokens.text.link;

    return (
        <>
            <HoverIconButton
                ref={triggerRef}
                title={message}
                ariaLabel={message}
                icon={icon}
                hoverIcon={icon}
                color={color}
                hoverColor={hoverColor}
                onClick={(e) => {
                    stopEvent(e);
                    toggleOpen();
                }}
            />
            {isOpen && (
                <TriggeredPopup
                    ref={popupRef}
                    anchorRef={triggerRef}
                    onClose={close}
                    test-id="IssueDisabledPopup__Popup"
                >
                    <div ref={contentRef}>{message}</div>
                </TriggeredPopup>
            )}
        </>
    );
}
